import React from 'react';
import classNames from 'classnames';
import SwipableDrawer from '@mui/material/SwipeableDrawer';
import DrawerHeader from './DrawerHeader';
import classes from './Drawer.module.scss';

function Drawer({
  children,
  anchor,
  open,
  onOpen,
  onClose,
  className,
  paperClassName,
  containerClassName,
  showHeader = true,
  variant,
  ...otherProps
}) {
  const paperClasses = classNames(paperClassName, classes.paperContent);
  const containerClasses = classNames(classes.content, containerClassName);

  return (
    <SwipableDrawer
      open={open}
      anchor={anchor}
      onClose={onClose}
      onOpen={onOpen}
      variant={variant}
      PaperProps={{ className: paperClasses }}
      className={className}
      transitionDuration={{ enter: 400, exit: 400 }}
      disableSwipeToOpen
    >
      {showHeader && <DrawerHeader {...otherProps} closeDrawer={onClose} />}
      <div className={containerClasses}>{children}</div>
    </SwipableDrawer>
  );
}

export default Drawer;
